import { render, staticRenderFns } from "./AssetVideoOriginalInfo.vue?vue&type=template&id=6c031d62&lang=pug"
import script from "./AssetVideoOriginalInfo.vue?vue&type=script&lang=js"
export * from "./AssetVideoOriginalInfo.vue?vue&type=script&lang=js"
import style0 from "./AssetVideoOriginalInfo.vue?vue&type=style&index=0&id=6c031d62&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports